import React from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalHeader, ModalContent } from '@tamagoshi/core/Modal';
import Spacing from '@tamagoshi/core/Spacing';
import { getTranslations } from '@translations';

const CompanyInfo = ({ isVisible, onClose }) => {
  const translations = getTranslations();

  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <ModalHeader>{translations('footer.company')}</ModalHeader>
      <ModalContent>
        {translations('footer.company.address')}
        <Spacing type="mt" size={8}>
          <div>
            {translations('footer.company.details.title')} <br />
            {translations('footer.company.details.description')}
          </div>
        </Spacing>
      </ModalContent>
    </Modal>
  );
};

CompanyInfo.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

CompanyInfo.displayName = 'CompanyInfo';

export default CompanyInfo;
